/**
 * @file: factory.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { VehicleBrandCriterion } from '@euler/app/tv/functions/search-criteria/criterions/brand';
import { CustomerTypeCriterion } from '@euler/app/tv/functions/search-criteria/criterions/customerType';
import { FuelTypeCriterion } from '@euler/app/tv/functions/search-criteria/criterions/fuelType';
import { MileageRangeCriterion } from '@euler/app/tv/functions/search-criteria/criterions/mileageRange';
import { OrderDateRangeCriterion } from '@euler/app/tv/functions/search-criteria/criterions/orderDateRange';
import { OrderTagCriterion } from '@euler/app/tv/functions/search-criteria/criterions/orderTag';
import { ServiceAgentCriterion } from '@euler/app/tv/functions/search-criteria/criterions/serviceAgent';
import { TaskStatusCriterion } from '@euler/app/tv/functions/search-criteria/criterions/taskStatus';
import { GenericBooleanTypeCriterion } from '@euler/app/tv/functions/search-criteria/GenericBooleanTypeCriterion';
import {
  SearchCriterionProvider,
  SearchCriterionType,
  SearchCriterionValueType,
} from './types';

export const orderedCriterionTypes: SearchCriterionType[] = [
  'orderDateRange',
  'serviceAgent',
  'vehicleBrand',
  'vehicleFuelType',
  'mileageRange',
  'status',
  'tag',
  'customerIsOnSite',
  'carwash',
  'customerType',
];

const factory: { [p in SearchCriterionType]: SearchCriterionProvider<any> } = {
  carwash: GenericBooleanTypeCriterion.create('是否洗车', 'carwash'),
  customerIsOnSite: GenericBooleanTypeCriterion.create(
    '在厂等待',
    'customerIsOnSite',
  ),
  customerType: CustomerTypeCriterion.shared,
  mileageRange: MileageRangeCriterion.shared,
  orderDateRange: OrderDateRangeCriterion.shared,
  serviceAgent: ServiceAgentCriterion.shared,
  status: TaskStatusCriterion.shared,
  tag: OrderTagCriterion.shared,
  vehicleBrand: VehicleBrandCriterion.shared,
  vehicleFuelType: FuelTypeCriterion.shared,
};

export function getSearchCriterionProvider<
  T extends SearchCriterionType,
  U = SearchCriterionValueType<T>,
>(type: T): SearchCriterionProvider<T, U> {
  return factory[type];
}

export function getAllCriterionProviders() {
  return orderedCriterionTypes.map(type => getSearchCriterionProvider(type));
}
